var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile h-border-custom h-overflow-hide has-background-custom"},[_c('iframe',{attrs:{"src":_vm.setPlay,"width":_vm.isMobile ? '95%':'100%',"height":"80","frameborder":"0","allowtransparency":"true","allow":"encrypted-media"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }